import { createApp } from "vue";
import PreferencesQuestionnaire from "@/app/javascript/components/catalog/PreferencesQuestionnaire.vue";
import router from "../routers/preferencesQuestionnaire";
import store from "../store/preferencesQuestionnaire";
import I18n from "../plugins/i18n";

import { ready } from "../utils/listeners";

ready(() => {
  const appLaunchCta = document.getElementById("preferences-app-start-cta");
  const questionnaireNode = document.getElementById("questionnaire-app");
  if (!appLaunchCta || !questionnaireNode) return;

  const landingNode = document.getElementById("preferences-landing-page");

  const translations = JSON.parse(questionnaireNode.dataset.translations);
  const storeData = JSON.parse(questionnaireNode.dataset.state);

  const app = createApp(PreferencesQuestionnaire, {
    name: "PreferencesQuestionnaire",
    landingNode,
    questionnaireNode
  });

  const showApp = e => {
    e.preventDefault();
    router.push("/picks-for-you/step-one");
  };

  app.use(router);
  app.use(store);
  app.use(I18n, translations);

  store.commit("setAllDiariesPath", storeData.allDiariesPath);

  appLaunchCta.addEventListener("click", showApp);

  app.mount(questionnaireNode);
});
